import axios from "axios";
import polyline from "@mapbox/polyline";

export const useRouting = () => {
  const calculateRoutingInfo = async (payload) => {
    const response = await axios.post(
      `${process.env.VUE_APP_API_URL}/api/gis/routing/get-route`,
      payload,
    );

    const { trip } = response.data;

    const combinedCoordinates = trip.legs.flatMap((leg) => {
      const decodedGeometry = polyline.decode(leg.shape, 6);
      return decodedGeometry.map(([lat, lon]) => [lon, lat]);
    });

    const geoJsonGeometry = {
      type: "LineString",
      coordinates: combinedCoordinates,
    };

    return { trip, geoJsonGeometry };
  };

  return { calculateRoutingInfo };
};
